import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import {ConfirmDialogComponent, ConfirmDialogData} from '../components/confirm-dialog';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private dialogRef?: MatDialogRef<any>;

  constructor(private dialog: MatDialog) {}

  /** Close all open dialogs */
  closeAll() {
    this.dialog.closeAll();
  }

  /** Open any dialog component */
  open<T, D = any, R = any>(
    component: T,
    data?: D,
    config?: MatDialogConfig<D>
  ): MatDialogRef<T, R> {
    this.dialog.closeAll();

    this.dialogRef = this.dialog.open(component as any, {
      width: '400px',
      data,
      disableClose: true,
      ...config,
    });

    return this.dialogRef;
  }

  confirm(data: ConfirmDialogData) {
    return this.open(ConfirmDialogComponent, data, {
      width: '550px',
      disableClose: true,
    }).afterClosed();
  }

}
